var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicationsTaken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10160_7486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0792 2.50656C14.0681 1.51775 15.3865 0.959961 16.8063 0.959961C18.2261 0.959961 19.5445 1.51775 20.5334 2.50656C21.5222 3.49538 22.08 4.81379 22.08 6.23362C22.08 7.6281 21.5222 8.97187 20.5334 9.96068L15.995 14.4991L14.4991 15.995L9.96068 20.5334C8.97187 21.5222 7.6281 22.08 6.23362 22.08C4.83914 22.08 3.49538 21.5222 2.50656 20.5334C1.51775 19.5445 0.959961 18.2261 0.959961 16.8063C0.959961 15.4118 1.51775 14.0681 2.50656 13.0792L7.04496 8.54085L8.54085 7.04496L13.0792 2.50656ZM3.59875 19.4375C4.91634 20.7551 7.24314 20.7551 8.56072 19.4375L13.5507 14.4195L11.0838 11.9525L8.61679 9.48557L3.59875 14.5036C2.92594 15.1484 2.5615 16.0455 2.5615 16.9706C2.5615 17.8957 2.92594 18.7647 3.59875 19.4375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10160_7486)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.04,
    height: 23.04,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationsTaken);
export default __webpack_public_path__ + "static/media/MedicationsTaken.cb2f4e3e2d59eafa0094fb16ff356648.svg";
export { ForwardRef as ReactComponent };